import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/club`;
const TOKEN_KEY = "club_token";
export const CLUB_BASE = process.env.REACT_APP_CLUB_STANDALONE === "1" ? "" : "/club";
export const getClubToken = () => localStorage.getItem(TOKEN_KEY);
export const setClubToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearClubToken = () => localStorage.removeItem(TOKEN_KEY);

export const club = axios.create({ baseURL: API, withCredentials: true });
club.interceptors.request.use((cfg) => {
  const t = getClubToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const d = (p) => p.then((r) => r.data);
export const getConfig = () => d(club.get("/config"));
export const getIncaricata = (slug) => d(club.get(`/i/${slug}`));
export const submitTest = (payload) => d(club.post("/test", payload));
export const getClient = (token) => d(club.get(`/c/${token}`));
export const postCheckin = (token, payload) => d(club.post(`/c/${token}/checkin`, payload));
export const putRoutine = (token, giorno, fatti) => d(club.put(`/c/${token}/routine`, { giorno, fatti }));
export const getPushKey = () => d(club.get("/push/key"));
export const savePush = (token, sub) => d(club.put(`/c/${token}/push`, sub));
export const deletePush = (token, endpoint) => d(club.delete(`/c/${token}/push`, { data: { endpoint } }));

export const exchangeSession = (session_id) => d(club.post("/auth/session", { session_id }));
export const me = () => d(club.get("/auth/me"));
export const logout = () => d(club.post("/auth/logout"));
export const updateMe = (payload) => d(club.put("/me", payload));
export const listClienti = () => d(club.get("/clienti"));
export const getCliente = (id) => d(club.get(`/clienti/${id}`));
export const setPiano = (id, payload) => d(club.put(`/clienti/${id}/piano`, payload));
export const setProposte = (id, proposte) => d(club.put(`/clienti/${id}/proposte`, { proposte }));
export const clearProposte = (id) => d(club.delete(`/clienti/${id}/proposte`));
export const updateCliente = (id, payload) => d(club.put(`/clienti/${id}`, payload));
export const addAppunto = (id, testo) => d(club.post(`/clienti/${id}/appunti`, { testo }));
export const delAppunto = (id, aid) => d(club.delete(`/clienti/${id}/appunti/${aid}`));
export const scegliProposta = (token, proposta_id) => d(club.post(`/c/${token}/scegli`, { proposta_id }));
export const deleteCliente = (id) => d(club.delete(`/clienti/${id}`));
export const getStats = (mese) => d(club.get("/stats", { params: { mese } }));
export const getMyTpl = () => d(club.get("/me/messaggi"));
export const saveMyTpl = (tpl) => d(club.put("/me/messaggi", { tpl }));
export const getMessaggi = (id) => d(club.get(`/clienti/${id}/messaggi`, { params: { base: `${window.location.origin}${CLUB_BASE}` } }));
export const listProdotti = () => d(club.get("/prodotti"));
export const upsertProdotto = (payload) => d(club.put("/prodotti", payload));
export const listTeam = () => d(club.get("/team"));
export const setRole = (user_id, role) => d(club.put(`/team/${user_id}/role`, { role }));

export const AREA_LABEL = { energia: "Energia", sonno: "Sonno", digestione: "Digestione", movimento: "Movimento", alimentazione: "Alimentazione", acqua: "Idratazione", stress: "Stress" };
export const OBIETTIVO_LABEL = { energia: "Energia", digestione: "Digestione", peso: "Peso e forma", pelle: "Pelle", sonno: "Sonno", sport: "Sport", difese: "Difese", articolazioni: "Articolazioni" };
